import { render, staticRenderFns } from "./TrialsByTeam.vue?vue&type=template&id=7b517abc&"
import script from "./TrialsByTeam.vue?vue&type=script&lang=js&"
export * from "./TrialsByTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports